import {
  useGetApiV1ExamExamGradeCriteria,
  useGetApiV1ExamExamReferenceShow,
  useGetApiV1ExamExamTypes,
} from '@/shared/api/generated';
import { unwrapPagedResponse } from '@/shared/utils/unwrapPagedResponse';

/**
 * Hook para carregar as opções dos selects do formulário de prova via API.
 *
 * Agrega os três endpoints de configuração — tipos de prova, critérios de nota
 * e modos de exibição do gabarito — em uma única chamada unificada.
 *
 * @returns Opções de tipo, critério de nota e exibição de gabarito com estado de loading
 *
 * @example
 * ```tsx
 * const { examTypes, gradeCriteriaOptions, referenceShowOptions } = useExamFormOptions();
 * ```
 */
export function useExamFormOptions() {
  const { data: rawExamTypes, isLoading: loadingTypes } = useGetApiV1ExamExamTypes();
  const { data: rawGradeCriteria, isLoading: loadingGrade } = useGetApiV1ExamExamGradeCriteria();
  const { data: rawReferenceShow, isLoading: loadingRef } = useGetApiV1ExamExamReferenceShow();

  return {
    examTypes: unwrapPagedResponse(rawExamTypes),
    gradeCriteriaOptions: unwrapPagedResponse(rawGradeCriteria),
    referenceShowOptions: unwrapPagedResponse(rawReferenceShow),
    isLoading: loadingTypes || loadingGrade || loadingRef,
  } as const;
}
